//导航目录列表
import { useStore } from "@/store";
export const inspectopenMenuList: object[] = [
    {
        title: '线下（教室）督导巡课',
        path: '/inspectopen',
        icon: 'icon-wangluoxunke',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '基于课表教室巡课',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/classRoomStatisticsCourseList?classmonitor=1' 
            },
            {
                title: '实时教室巡课',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/classroomLive'
            },
            {
                title: '实时教室多画面',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/multiview'
            },
            {
                title: '历史教室巡课',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/historyClassroomLive'
            },
            {
                title: '历史教室巡课多画面',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/historyMultiview'
            },
            {
                title: '巡课统计',
                alwaysShow: true,
                role: ['34090','MDAwMDAwMDAwMLOstduIuad1'],
                // role: ['0', '1', '2', '3', '4'],
                path: 'http://10.9.22.6'
            },
            {
                title: '巡课记录',
                alwaysShow: true,
                role: ['34090','MDAwMDAwMDAwMLOstduIuad1'],
                // role: ['0', '1', '2', '3', '4'],
                path: 'http://10.9.22.7'
            },
            {
                title: '同步数据',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/inspectopen/synchronousData',
            }
        ]
    }
]
